import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux"
import API from "service/API";
import { setCashflowStockAnalysisMomentum, setOverviewMomentum } from "store/actionReducers/MomentumStore";
import useA from "./useA";

const useMomentum = () => {
  const dispatch = useDispatch();
  const { BothValueOverview } = useA();
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)

  const fetchOverviewMomentum = useCallback(async (ticker: string) => {
    const res = await API.Momentum.getOverview(ticker)

    if (res?.code === '0') {
      dispatch(setOverviewMomentum(res?.data))
    }
  }, [StocksAnalysisStore?.inputSearch])

  const fetchCashflowStockAnalysis = useCallback(async (stock) => {
    const res = await API.Market.marketCashflowStockCode(stock)

    if (res?.code === '0') {
      dispatch(setCashflowStockAnalysisMomentum(res?.data))
    }
  }, [])

  const compareDataOverview = (Overview: any, IcbOverview: any) => {
    let uptrend = '0'
    if (Overview?.uptrendRank) {
      uptrend = typeof Overview?.uptrendRank === 'string' ? parseFloat(Overview?.uptrendRank).toFixed(2) : Overview?.uptrendRank.toFixed(2)
    }
    let uptrendicb = '0'
    if (IcbOverview?.icbUptrend) {
      uptrendicb = typeof IcbOverview?.icbUptrend === 'string' ? parseFloat(IcbOverview?.icbUptrend).toFixed(2) : IcbOverview?.icbUptrend.toFixed(2)
    }
    let liquidity = '0'
    if (Overview?.liquidity) {
      liquidity = typeof Overview?.liquidity === 'string' ? parseFloat(Overview?.liquidity).toFixed(2) : Overview?.liquidity.toFixed(2)
    }
    let icbLiquidity = '0'
    if (IcbOverview?.icbLiquidity) {
      icbLiquidity = typeof IcbOverview?.icbLiquidity === 'string' ? parseFloat(IcbOverview?.icbLiquidity).toFixed(2) : IcbOverview?.icbLiquidity.toFixed(2)
    }
    let buyPoint = '0'
    if (Overview?.liquidity) {
      buyPoint = typeof Overview?.buyPoint === 'string' ? parseFloat(Overview?.buyPoint).toFixed(2) : Overview?.buyPoint.toFixed(2)
    }
    let icbBuyPoint = '0'
    if (IcbOverview?.icbBuyPoint) {
      icbBuyPoint = typeof IcbOverview?.icbBuyPoint === 'string' ? parseFloat(IcbOverview?.icbBuyPoint).toFixed(2) : IcbOverview?.icbBuyPoint.toFixed(2)
    }
    let marcap = '0'
    if (Overview?.liquidity) {
      marcap = typeof Overview?.marcapRank === 'string' ? parseFloat(Overview?.marcapRank).toFixed(2) : Overview?.marcapRank.toFixed(2)
    }
    let icbMarcap = '0'
    if (IcbOverview?.icbMarcap) {
      icbMarcap = typeof IcbOverview?.icbMarcap === 'string' ? parseFloat(IcbOverview?.icbMarcap).toFixed(2) : IcbOverview?.icbMarcap.toFixed(2)
    }

    const dataNew: any = {
      uptrend: BothValueOverview(uptrend, uptrendicb),
      uptrend_value: [uptrend, uptrendicb],
      liquidity: BothValueOverview(liquidity, icbLiquidity),
      liquidity_value: [liquidity, icbLiquidity],
      buyPoint: BothValueOverview(buyPoint, icbBuyPoint),
      buyPoint_value: [buyPoint, icbBuyPoint],
      marcap: BothValueOverview(marcap, icbMarcap),
      marcap_value: [marcap, icbMarcap],
    }
    return dataNew;
  }

  return {
    fetchOverviewMomentum,
    fetchCashflowStockAnalysis,
    compareDataOverview,
  }
}

export default useMomentum